import React from 'react';

import {useSnackbar} from 'notistack';
import {useHistory} from 'react-router';

import {Constants, Messages, SnackbarVariants, ViewKeys} from 'commons/constants';
import {useSpinner} from 'hooks';
import {getBase64Extension, nextStep} from 'commons/utils/Functions';
import {DocumentServices} from 'services';
import {MainContent} from 'layouts/commons';
import TaxIdForm from './tax-id-form/TaxIdForm';
import {useFlowContext} from 'context/onboarding-flow/OnboardingFlow';
import {useMenuContext} from 'context/onboarding-menu/OnboardingMenu';
import {TaxIdValues} from 'commons/models/modules/content/TaxIdValues';
import {Documents, EfeResponse, UploadDocumentServiceRequest} from 'commons/models';

function TaxId() {
    const history = useHistory();
    const {flow, updateModuleStep} = useFlowContext();
    const {menu, expedientId, fatherKycId} = useMenuContext();
    const {enqueueSnackbar} = useSnackbar();
    const [isLoading, setIsLoading] = React.useState(false);
    const [taxId, setTaxId] = React.useState<any>(undefined);

    React.useEffect(() => {
        if (fatherKycId > 0 && ViewKeys.DATA_DOCUMENTATION_TAX_ID === flow.data.expandKey) {
            setIsLoading(true);
            (async function () {
                try {
                    const response: EfeResponse<Documents> =
                        await DocumentServices.getDocumentByKycId(
                            Constants.DOC_CEDULA_FISCAL,
                            expedientId,
                            fatherKycId
                        );
                    if (response && response.data) {
                        setTaxId(response.data.data);
                    }
                    setIsLoading(false);
                } catch (error) {
                    setIsLoading(false);
                }
            })();
        }
    }, []);

    async function onSubmit(values: TaxIdValues) {
        setIsLoading(true);
        try {
            const extension = getBase64Extension(values.file);
            const fileConverted = await (await fetch(values.file)).blob();
            const request: UploadDocumentServiceRequest = {
                documentKey: Constants.DOC_CEDULA_FISCAL,
                expedientId: expedientId,
                file: fileConverted,
                kycId: fatherKycId,
                filename: `${Constants.DOC_CEDULA_FISCAL}.${extension}`,
            };
            const response: EfeResponse<any> = await DocumentServices.updateDocument(request);
            if (response && response.data) {
                enqueueSnackbar(Messages.FILE_UPLOAD_OK, {
                    variant: SnackbarVariants.SUCCESS,
                });
                const path = nextStep(flow, menu);
                if (Constants.MODULE_STEP !== path) {
                    setIsLoading(false);
                    history.push(path);
                } else {
                    updateModuleStep(true);
                    flow.data.expandKey = path;
                    setIsLoading(false);
                }
            } else {
                setIsLoading(false);
            }
        } catch (error) {
            console.error(error);
            setIsLoading(false);
            enqueueSnackbar(Messages.FILE_NOT_UPLOAD, {
                variant: SnackbarVariants.ERROR,
            });
        }
    }
    return (
        <MainContent>
            {isLoading && useSpinner(isLoading)}
            {!isLoading && <TaxIdForm submitHandler={onSubmit} taxId={taxId} />}
        </MainContent>
    );
}

export default TaxId;
